import { Injectable } from '@angular/core';
import { ICadType } from '../../../../models/document/cad-type.model';
import { ICadSimpleType } from '../../../../models/document/cad-simple-type.model';

@Injectable({
  providedIn: 'root',
})
export class CadfileTypeHelperService {
  constructor() {}

  public getCadFileTypeWithUniqueFormats(
    index: number,
    cadFileTypes: ICadType[],
    selectedCadFileTypeViews: ICadSimpleType[] = []
  ): string[] {
    let returnValue: string[] = [];
    if (selectedCadFileTypeViews[index].cadFormat) {
      returnValue = cadFileTypes
        ?.filter(
          (cadFileType: ICadType) =>
            cadFileType.cadFormat === selectedCadFileTypeViews[index].cadFormat
        )
        .map((cadFileType: ICadType) => cadFileType?.cadFileType);
    }

    return returnValue;
  }

  public getCadFileTypeWithUniqueViews(cadFileTypes: ICadType[]): string[] {
    const cadFileTypesIsSet: string[] = cadFileTypes?.map(
      (cadFileType: ICadType) =>
        cadFileType?.docTypeId && cadFileType?.cadFormat
    );
    let uniques: string[] = [...new Set(cadFileTypesIsSet)];
    return uniques;
  }
}
